import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Map, List } from 'immutable'

@Component({
  selector: 'app-form-builder-row',
  templateUrl: './form-builder-row.component.html',
  styleUrls: ['./form-builder-row.component.css'],
})
export class FormBuilderRowComponent implements OnInit {
  @Input('row') public row: Map<string, any>
  @Input('index') public index: number
  @Input('isPropertyType') public isPropertyType: boolean
  @Output() onAddInput: EventEmitter<any> = new EventEmitter()
  @Output() onAddSelect: EventEmitter<any> = new EventEmitter()
  @Output() onDeleteRow: EventEmitter<any> = new EventEmitter()
  @Output() onDeleteOption: EventEmitter<any> = new EventEmitter()
  @Output() onAddOption: EventEmitter<any> = new EventEmitter()
  @Output() onChangeField: EventEmitter<any> = new EventEmitter()
  @Output() onChangeOptionsOrder: EventEmitter<any> = new EventEmitter()
  @Input('isDuplicate') public isDuplicate: boolean

  public formId: any

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.formId = parseInt(this.route.snapshot.paramMap.get('id'))
  }

  addInput(path = []) {
    this.onAddInput.emit([this.index, 'options', ...path])
  }

  addSelect(path = []) {
    this.onAddSelect.emit([this.index, 'options', ...path])
  }

  deleteRow(path = []) {
    this.onDeleteRow.emit([this.index, 'options', ...path])
  }

  addOption(path = []) {
    this.onAddOption.emit([this.index, 'options', ...path])
  }

  deleteOption(path = []) {
    this.onDeleteOption.emit([this.index, 'options', ...path])
  }

  handleFieldChange({ e, path = [] }) {
    this.onChangeField.emit({
      e,
      path: [this.index, 'options', ...path],
    })
  }

  handleOptionsOrderChange({ option, direction, path = [] }) {
    this.onChangeOptionsOrder.emit({
      option,
      direction,
      path: [this.index, 'options', ...path],
    })
  }
}
